module.exports = __webpack_public_path__ + "img/neymar-mbappe.bf002318.jpg";